import { render, staticRenderFns } from "./BrokerDeclarationSummary.vue?vue&type=template&id=1078215f&scoped=true"
import script from "./BrokerDeclarationSummary.vue?vue&type=script&lang=js"
export * from "./BrokerDeclarationSummary.vue?vue&type=script&lang=js"
import style0 from "./BrokerDeclarationSummary.vue?vue&type=style&index=0&id=1078215f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1078215f",
  null
  
)

export default component.exports